<template>
  <div class="privacy-policy-page">
    <!-- 顶部导航栏 -->
    <!-- 导航栏 -->
    <header class="sticky top-0 z-50 bg-white bg-opacity-90 backdrop-blur shadow-sm py-4 h-24">
      <div class="container mx-auto px-10">
        <div class="flex justify-between items-center">
          <div class="cursor-pointer">
           <router-link to="/" >
           	<img src="../assets/logo.png" width="164px" height="60px" />
           </router-link>
          </div>
          <nav class="hidden md:flex gap-8 text-sm text-gray-600">
           <router-link to="/banking"  class="nav-link">Banking</router-link>
           <router-link to="/exchange"  class="nav-link">Exchange</router-link>
           <router-link to="/issuing"  class="nav-link">Issuing</router-link>
           <router-link to="/acquiring"  class="nav-link">Acquiring</router-link>
           <router-link to="/company"  class="nav-link">Company</router-link>
          </nav>
          <button class="bg-primaryBlue text-white px-5 py-2 rounded-full text-sm font-medium hover:bg-primaryBlueDark transition-colors" @click="scrollToWithOffset('4700')">
            Get Started
          </button>
        </div>
      </div>
    </header>

<main class="container mx-auto px-4 max-w-[1280px] py-10">
    <h1 class="text-[clamp(1.5rem,3vw,2.5rem)] font-bold text-gray-900 mb-8" style="color:#1f72d8;font-size: 3rem;">Privacy Policy</h1>

    <!-- 第一部分：双栏布局 -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12 text-gray-800 rounded-lg shadow-sm" style="background:#F5F9FF;border:1px solid #fff;">
      <!-- 左侧 -->
      <div class="content-left">
        <section class="p-6 text-left ">
          <div class="text-lg font-semibold text-gray-900 mb-5">Introduction and Legal Basis</div>
          <div class="text-gray-700 leading-relaxed ">
            This Privacy Policy ("Policy") explains how Unipay Global Ltd, ("we", "us" or "our") collects, uses, discloses, and protects your personal information in compliance with applicable data protection laws, including but not limited to the Personal Information Protection Law of the People's Republic of China (PIPL), the EU General Data Protection Regulation (GDPR), and other relevant privacy laws. By using our services, you agree to the practices described in this Policy. If you do not agree with this Policy, please do not use our services.
          </div>
        </section>
      </div>

      <!-- 右侧 -->
      <div class="content-right">
        <section class="p-6 text-left">
          <h2 class="text-lg font-semibold text-gray-900 mb-5">Privacy Policy - The Basics</h2>
          <p class="text-gray-700 leading-relaxed mb-4">
            Having said that, a privacy policy is a statement that discloses some or all of the ways a website collects, uses, discloses, processes, and manages the data of its visitors and customers. It usually includes a statement regarding the website's treatment of personally identifiable information, or "customer" privacy, and an explanation about the different mechanisms the website is implementing in order to protect privacy.
          </p>
          <p class="text-gray-700 leading-relaxed">
            Different jurisdictions have different legal obligations of which you must be included in a Privacy Policy. You are responsible to make sure you are following the relevant legislation to your activities and location.
          </p>
        </section>
      </div>
    </div>

    <!-- 第二部分：长内容双栏 -->
    <div  style="background:#F5F9FF;border:1px solid #fff;py-10" class="rounded-lg">
      <h2 class="text-xl font-bold text-gray-900 mb-2 mt-10">What to Include in the Privacy Policy</h2>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
        <!-- 左侧大段内容 -->
        <div class="content-left space-y-6 text-left">
          <section class="p-6">
            <!-- 1. Scope -->
            <div class="mb-6">
              <h3 class="font-semibold text-gray-900 mb-2">1. Scope of Application</h3>
              <p class="text-gray-700 leading-relaxed">
                This Policy applies to all personal data collected, stored, used, or shared by Unipay Global Ltd, when you access our website, platform, products, or services, whether via web browser, mobile device, or any other method.
              </p>
            </div>

            <!-- 2. Data Collected -->
            <div class="mb-6">
              <h3 class="font-semibold text-gray-900 mb-2">2. Types of Data Collected</h3>
              <div class="pl-5 space-y-4">
                <div>
                  <h4 class="font-medium text-gray-800">2.1 Personal Data</h4>
                  <p class="text-gray-700 leading-relaxed mt-1">
                    We collect personally identifiable information ("personal data") that can be used to identify or contact you, including but not limited to:
                  </p>
                  <ul class="list-disc list-inside text-gray-700 mt-2 space-y-1">
                    <li>Full name, gender, date of birth;</li>
                    <li>Identification information (e.g., ID card, passport, driver's license);</li>
                    <li>Contact information (e.g., address, phone number, email);</li>
                    <li>Account details and transaction records;</li>
                    <li>KYC/AML verification documentation.</li>
                  </ul>
                </div>

                <div>
                  <h4 class="font-medium text-gray-800">2.2 Sensitive Personal Data</h4>
                  <p class="text-gray-700 leading-relaxed mt-1">
                    We may also collect sensitive personal data as defined under applicable laws, including biometric data, religious beliefs, financial account information, health and medical records, location data, and personal data of individuals under 14 years of age. Such data will only be collected when strictly necessary and with explicit consent.
                  </p>
                </div>

                <div>
                  <h4 class="font-medium text-gray-800">2.3 Aggregate and Anonymized Data</h4>
                  <p class="text-gray-700 leading-relaxed mt-1">
                    We may collect and process de-identified and aggregated data for statistical or analytical purposes, which cannot be used to identify any individual.
                  </p>
                </div>

                <div>
                  <h4 class="font-medium text-gray-800">2.4 Client Data</h4>
                  <p class="text-gray-700 leading-relaxed mt-1">
                    Any files or content uploaded or processed through the services by our users, including information related to employment, payment, repayment, recruitment, or clients.
                  </p>
                </div>

                <div>
                  <h4 class="font-medium text-gray-800">2.5 Cookies</h4>
                  <p class="text-gray-700 leading-relaxed mt-1">
                    We use cookies and similar tracking technologies to enhance functionality, personalize content, analyze website usage, and support security. Cookies we may include:
                  </p>
                  <ul class="list-disc list-inside text-gray-700 mt-1 space-y-1">
                    <li>Essential Cookies</li>
                    <li>Analytical Cookies</li>
                    <li>Functional Cookies</li>
                  </ul>
                  <p class="text-gray-700 leading-relaxed mt-1">
                    You can control cookie preferences through your browser settings or our cookie management interface.
                  </p>
                </div>
              </div>
            </div>

            <!-- 3 ~ 8 统一结构 -->
            <div class="space-y-6">
              <div>
                <h3 class="font-semibold text-gray-900 mb-2">3. Purposes and Legal Basis of Processing</h3>
                <p class="text-gray-700 leading-relaxed mb-2">We process your personal data based on legitimate interests, contractual necessity, compliance with legal obligations, and, where applicable, your consent. Purposes include:</p>
                <ul class="list-disc list-inside text-gray-700 space-y-1">
                  <li>Verifying your identity and conducting KYC/AML checks;</li>
                  <li>Managing your account and service usage;</li>
                  <li>Providing customer support;</li>
                  <li>Processing transactions and service updates;</li>
                  <li>Conducting marketing communication (with your consent);</li>
                  <li>Preventing fraud, illegal activity, or harm;</li>
                  <li>Fulfilling contractual and legal obligations.</li>
                </ul>
              </div>

              <div>
                <h3 class="font-semibold text-gray-900 mb-2">4. Sharing of Data</h3>
                <p class="text-gray-700 leading-relaxed mb-2">We may disclose your data to third parties in the following situations:</p>
                <ul class="list-disc list-inside text-gray-700 space-y-1">
                  <li>Service providers (e.g., hosting, payment, IT support);</li>
                  <li>Regulatory and government authorities (as required by law);</li>
                  <li>Auditors, legal and financial advisors;</li>
                  <li>Other users or organizations with your explicit consent.</li>
                </ul>
                <p class="text-gray-700 leading-relaxed mt-2">All third parties are contractually obligated to maintain the confidentiality and security of your data and may not use it for unrelated purposes.</p>
              </div>

              <div>
                <h3 class="font-semibold text-gray-900 mb-2">5. International Data Transfers</h3>
                <p class="text-gray-700 leading-relaxed mb-2">Your personal data may be transferred to and processed in countries outside of your jurisdiction, including countries with differing data protection standards. Where applicable, we implement safeguards such as:</p>
                <ul class="list-disc list-inside text-gray-700 space-y-1">
                  <li>Standard Contractual Clauses approved by the European Commission;</li>
                  <li>Other lawful transfer mechanisms as recognized under applicable data protection laws.</li>
                </ul>
                <p class="text-gray-700 leading-relaxed mt-2">If you are located in mainland China, cross-border transfers of your personal data will only be conducted in compliance with applicable Chinese cross-border transfer PIPL filing, security assessments or certification obligations where required.</p>
              </div>

              <div>
                <h3 class="font-semibold text-gray-900 mb-2">6. Data Retention</h3>
                <p class="text-gray-700 leading-relaxed">We retain personal data only for as long as necessary to fulfill the purposes for which it was collected and to comply with legal, regulatory, and contractual obligations. In most cases, data will be retained for no more than 5 to 10 years, depending on applicable law.</p>
                <p class="text-gray-700 leading-relaxed mt-2">In certain cases, personal data may not be immediately deletable due to:</p>
                <ul class="list-disc list-inside text-gray-700 mt-1 space-y-1">
                  <li>Legal or regulatory requirements;</li>
                  <li>Ongoing contractual obligations;</li>
                  <li>Technical constraints such as system backups;</li>
                  <li>Exercise or defense of legal claims.</li>
                </ul>
                <p class="text-gray-700 leading-relaxed mt-2">Users may request deletion of their data by contacting us, and we will process such requests in accordance with applicable law.</p>
              </div>

              <div>
                <h3 class="font-semibold text-gray-900 mb-2">7. Security Measures</h3>
                <p class="text-gray-700 leading-relaxed mb-2">We implement appropriate technical and organizational security measures to protect your data, including:</p>
                <ul class="list-disc list-inside text-gray-700 space-y-1">
                  <li>Access control and role-based permissions;</li>
                  <li>Encryption and secure data transmission protocols;</li>
                  <li>Monitoring and response procedures for data breaches.</li>
                </ul>
                <p class="text-gray-700 leading-relaxed mt-2">We also require all employees and contractors with access to personal data to maintain confidentiality.</p>
              </div>

              <div>
                <h3 class="font-semibold text-gray-900 mb-2">8. Your Rights</h3>
                <p class="text-gray-700 leading-relaxed mb-2">Depending on your location and applicable law, you may have the right to:</p>
                <ul class="list-disc list-inside text-gray-700 space-y-1">
                  <li>Access, correct, or delete your personal data;</li>
                  <li>Restrict or object to certain processing activities;</li>
                  <li>Withdraw consent at any time (where applicable);</li>
                  <li>Receive a copy or export portability of your data;</li>
                  <li>File a complaint with a data protection authority.</li>
                </ul>
              </div>
            </div>
          </section>
        </div>

        <!-- 右侧内容 -->
        <div class="content-right space-y-6 text-left">
          <section class="p-6">
            <h3 class="font-semibold text-gray-900 mb-2">9. Children's Privacy</h3>
            <p class="text-gray-700 leading-relaxed mb-3">Our services are not intended for individuals under the age of 14 (or the applicable age of majority based on your jurisdiction). In not knowingly collect personal data from minors. If we become aware that personal information has been collected from a child without verified parental consent, we will delete such data.</p>
            <p class="text-gray-700 leading-relaxed mb-3">We encourage parents and guardians to monitor their child's online activities. If you are a parent or legal guardian and believe your child has provided us with personal data, please contact us.</p>
            <p class="text-gray-700 leading-relaxed">For jurisdictions where the definition of a child differs (e.g., under 13, 15, or 16 years old), we comply with the age limit as defined by the applicable local law.</p>
          </section>

          <section class="p-6">
            <h3 class="font-semibold text-gray-900 mb-2">10. EEA and UK Users - Additional Provisions</h3>
            <p class="text-gray-700 leading-relaxed mb-4">If you are a resident of the European Economic Area (EEA) or the United Kingdom (UK), the following provisions apply in addition to the terms outlined above:</p>

            <div class="space-y-4">
              <div>
                <h4 class="font-medium text-gray-800">10.1 Data Controller</h4>
                <p class="text-gray-700 leading-relaxed mt-1">Unipay Global Ltd. is the data controller for personal data collected under this Policy, unless otherwise stated. You may contact our Data Protection Officer using the contact details in Section 12.</p>
              </div>
              <div>
                <h4 class="font-medium text-gray-800">10.2 Lawful Basis</h4>
                <p class="text-gray-700 leading-relaxed mt-1">We process your data based on the legal bases outlined in Article 6 of the GDPR and UK GDPR, including legitimate interests, legal obligations, and consent.</p>
              </div>
              <div>
                <h4 class="font-medium text-gray-800">10.3 Transfers</h4>
                <p class="text-gray-700 leading-relaxed mt-1 mb-2">Where we transfer your data outside the EEA or UK, we ensure appropriate safeguards are in place, including:</p>
                <ul class="list-disc list-inside text-gray-700 space-y-1">
                  <li>The use of EU Standard Contractual Clauses;</li>
                  <li>The UK International Data Transfer Agreement (IDTA) or Addendum to the SCCs;</li>
                  <li>Transfers to countries deemed by the European Commission or UK Secretary of State to have adequate data protection.</li>
                </ul>
              </div>
              <div>
                <h4 class="font-medium text-gray-800">10.4 Your Rights Under GDPR</h4>
                <p class="text-gray-700 leading-relaxed mt-1 mb-2">You have the right to:</p>
                <ul class="list-disc list-inside text-gray-700 space-y-1">
                  <li>Access your personal data;</li>
                  <li>Request correction or erasure of your data;</li>
                  <li>Restrict or object to processing;</li>
                  <li>Data portability;</li>
                  <li>Lodge a complaint with your local supervisory authority;</li>
                  <li>Withdraw consent where processing is based on consent.</li>
                </ul>
              </div>
            </div>
          </section>

          <section class="p-6">
            <h3 class="font-semibold text-gray-900 mb-2">11. Mainland China Users - Supplemental Provisions</h3>
            <p class="text-gray-700 leading-relaxed mb-3">(For purposes of this section, "China" refers to mainland China or the People's Republic of China (PRC), excluding the Hong Kong and Macau Special Administrative Regions and Taiwan.)</p>
            <p class="text-gray-700 leading-relaxed mb-4">If you are a resident of China, the following provisions apply in addition to this Policy:</p>

            <div class="space-y-4">
              <div>
                <h4 class="font-medium text-gray-800">11.1 Definition of Personal Information</h4>
                <p class="text-gray-700 leading-relaxed mt-1">"Personal information" refers to all kinds of information, recorded electronically or otherwise, that can be used to identify or contact a specific individual, in combination with other information. It excludes anonymized data. Examples include: name, date of birth, national ID/passport number, biometric information, contact details, address, account and financial information, geolocation data, communication records and contents, login credentials, account credit data, residence records, health or physiological data, and transaction information.

Information that, once leaked or misused, may endanger the safety of individuals or property, or infringe on personal dignity, is deemed "Sensitive Personal Information." This includes biometric identifiers, ID numbers, religious beliefs, specific social identity, health records, financial account details, location data, and personal data of individuals under the age of 14.</p>
              </div>
              <div>
                <h4 class="font-medium text-gray-800">11.2 Cross Border Transfers</h4>
                <p class="text-gray-700 leading-relaxed mt-1">In order to deliver and improve our services, we may transfer your personal information outside of China. Such transfers will only occur if we ensure that the receiving party will provide protection equivalent to that under Chinese law or where legally required safeguards have been implemented, such as undergoing security assessments or certification processes as prescribed by the PIPL.</p>
              </div>
              <div>
                <h4 class="font-medium text-gray-800">11.3 Your Rights Under PIPL</h4>
                <ul class="list-disc list-inside text-gray-700 mt-1 space-y-1">
                  <li>Request access to your data;</li>
                  <li>Request correction of inaccurate or incomplete data;</li>
                  <li>Request the scope of your prior consent;</li>
                  <li>Opt out of direct marketing communications;</li>
                  <li>Request erasure of your data under specified circumstances.</li>
                </ul>
              </div>
              <div>
                <h4 class="font-medium text-gray-800">11.5 Protection of Minors</h4>
                <p class="text-gray-700 leading-relaxed mt-1">If you are under 18 years old, you should obtain prior consent from your parent or guardian before using our services or providing personal data. We will only process minors' personal data in accordance with the PIPL.

If you are a parent or guardian and believe we may have collected personal data from your child without proper consent, please contact us immediately using the contact information in Section 12. We will delete such data promptly and ensure legal compliance in the handling of minors' information.</p>
              </div>
            </div>
          </section>

          <section class="p-6">
            <h3 class="font-semibold text-gray-900 mb-2">12. Contact Information</h3>
            <p class="text-gray-700 leading-relaxed mb-3">If you have any questions, concerns, or requests regarding this Privacy Policy or our data protection practices, please contact us at:</p>
            <p class="text-gray-700 font-medium">Unipay Global Ltd.<br>Bleistrasse 8, 6300 Zug, Switzerland</p>
          </section>
        </div>
      </div>
    </div>
  </main>
	
	<!-- 页脚 全部居中 -->
	  <footer class="text-white pt-16" style="background:#003372 ;">
	    <div class="max-w-[1280px] mx-auto px-10 grid grid-cols-1 md:grid-cols-2 gap-8">
	      <!-- 左侧区域 -->
	      <div class="flex flex-col gap-6">
	        <!-- Logo -->
	        <div class="mb-6">
	          <img src="../assets/logo-withe.png" alt="UNIPAY Logo" class="h-[50px] w-auto">
	        </div>
	
	        <!-- 导航 + 联系信息 行 -->
	        <div class="flex flex-wrap gap-8 md:gap-[80px]">
	          <!-- 第一列 -->
	          <div class="flex flex-col gap-5 text-left">
	            <router-link to="/" class="text-white text-base hover:text-gray-300">Home</router-link>
	            <router-link to="/banking" class="text-white text-base hover:text-gray-300">Banking</router-link>
	            <router-link to="/exchange" class="text-white text-base hover:text-gray-300">Exchange</router-link>
	            <router-link to="/acquiring" class="text-white text-base hover:text-gray-300">Acquiring</router-link>
	          </div>
	
	          <!-- 第二列 -->
	          <div class="flex flex-col gap-5 text-left">
	            <router-link to="/issuing" class="text-white text-base hover:text-gray-300">Issuing</router-link>
	            <router-link to="/company" class="text-white text-base hover:text-gray-300">Company</router-link>
	          </div>
	
	          <!-- 联系信息 -->
	          <div class="flex flex-col gap-5 text-left">
	            <div class="flex items-start gap-2">
	              <span class="text-lg">✉️</span>
	              <div>
	                <div class="text-white text-base">Email:</div>
	                <div class="text-white text-base">operation@unipay-global.com</div>
	              </div>
	            </div>
	            <div class="flex items-start gap-2">
	              <span class="text-lg">📍</span>
	              <div>
	                <div class="text-white text-base">Address:</div>
	                <div class="text-white text-base">Bleichistrasse 8, 6300 Zug,</div>
	                <div class="text-white text-base">Switzerland.</div>
	              </div>
	            </div>
	          </div>
	        </div>
	
	        <!-- 标语 -->
	        <div class="border-t border-white/20 pt-5 mt-2 text-lg text-left">
	          <p class="py-1">Professional, Intelligent Global Fund Management Partner</p>
	          <p class="py-1">Ready to streamline your global operations?</p>
	        </div>
	
	        <!-- 底部链接 -->
	        <div class="pt-4 flex gap-6">
	          <router-link to="/policy" class="text-white text-sm hover:underline">Privacy Policy</router-link>
	          <router-link to="/terms" class="text-white text-sm hover:underline">Terms & Conditions</router-link>
	        </div>
	      </div>
	
	      <!-- 右侧表单区域 -->
	      <div class="flex flex-col gap-6">
	        <h2 class="text-xl font-bold">Contact Us</h2>
	        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
	          <div class="form-group">
	            <label class="block text-sm mb-2">First name *</label>
	            <input type="text" v-model="firstName" required
	              class="w-full p-3 bg-transparent border border-white rounded-none text-white placeholder-white/70">
	          </div>
	          <div class="form-group">
	            <label class="block text-sm mb-2">Last name *</label>
	            <input type="text" v-model="lastName" required
	              class="w-full p-3 bg-transparent border border-white rounded-none text-white placeholder-white/70">
	          </div>
	          <div class="form-group">
	            <label class="block text-sm mb-2">Email *</label>
	            <input type="email" v-model="email" required
	              class="w-full p-3 bg-transparent border border-white rounded-none text-white placeholder-white/70">
	          </div>
	          <div class="form-group">
	            <label class="block text-sm mb-2">Phone *</label>
	            <input type="tel" v-model="phone"
	              class="w-full p-3 bg-transparent border border-white rounded-none text-white placeholder-white/70">
	          </div>
	          <div class="md:col-span-2">
	            <label class="block text-sm mb-2">Message *</label>
	            <textarea v-model="message" required rows="4"
	              class="w-full p-3 bg-transparent border border-white rounded-none text-white placeholder-white/70"></textarea>
	          </div>
	          <button id="submit-btn" @click="sendMsg"
	            class="md:col-span-2 bg-blue-600 hover:bg-blue-700 text-white py-3 font-medium transition-colors">
	            提交您的信息
	          </button>
	        </div>
	      </div>
	    </div>
	
	    <!-- 版权信息 -->
	    <div class="max-w-[1280px] mx-auto px-4 text-center py-6 mt-8 text-white text-sm border-t border-white/10">
	      <p>Copyright © 2025 UNIPAY GLOBAL. All rights reserved.</p>
	    </div>
	  </footer>
	
	  <div class="flex justify-center">
	    <IpAlert :visible="showAlert" :content="alertContent" @close="showAlert = false" />
	  </div>

  </div>
</template>


<style scoped>
			.privacy-policy-page{
			 background:#EBF3FF;
			}
</style>
<script setup>
	import axios from 'axios';
	import { ref } from 'vue';
	import IpAlert from "./IpAlert.vue"; // 引入弹窗组件
	// import { useRouter } from 'vue-router';
	
	// const router = useRouter();
    const firstName = ref('');
	const lastName = ref('');
	const phone = ref('');
	const email = ref('');
	const message = ref('');
	// 响应式变量：控制弹窗显示/隐藏
	const showAlert= ref(false);
    const alertContent =ref('');
	
	// export default {
	//   methods: {
	//     skipPolicy() {
	//        router.push({ name: 'Policy' });
	//     }
	//   }
	// }
	
	function scrollToWithOffset(top) {
	    window.scrollTo({ top, behavior: 'smooth' });
	}
	
	function sendMsg(){
		if(firstName.value  == ''){
			showAlert.value="true";
			alertContent.value="First name is null";
			return false;
		}
		if(lastName.value  == ''){
			showAlert.value="true";
			alertContent.value="Last name is null";
			return false;
		}
		if(!checkEmail(email.value)){
			showAlert.value="true";
			alertContent.value="email is error";
			return false;
		}
		if(phone.value  == ''){
			showAlert.value="true";
			alertContent.value="phone is null";
			return false;
		}
		if(message.value  == ''){
			showAlert.value="true";
			alertContent.value="message is null";
			return false;
		}
		axios.post('/api/email', {
		    firstName: firstName.value,        
		    lastName: lastName.value,
			phone:phone.value,
			email:email.value,  
			message:message.value
		  })
		  .then(function (response) {
			  const data =response.data;
			  if(data.code =='000'){
				  const btnByClass = document.getElementById('submit-btn');
				  btnByClass.disabled = true;
				  showAlert.value =true;
		          alertContent.value="Thank you for subscribing! You will now receive our latest updates. ";
			  }
		  })
		  .catch(function (error) {
		    console.log(error);
		  });
	}
	
	function checkEmail(email) {
	    // 空值/非字符串处理
	    if (!email || typeof email !== 'string') return false;
	    // 主流邮箱正则：支持字母/数字/下划线/点/减号 + @ + 域名 + 顶级域名(2-6位)
	    const emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
	    return emailReg.test(email.trim());
	}
	
	
</script>